import * as S from './PlacementsForm.styled';
import { CreatePlacementBtn } from 'components';
import Section from './components/Section';

const PlacementsForm = ({ data }) => {
  return (
    <S.Container>
      <S.Box>
        <Section data={data} />
        <CreatePlacementBtn />
      </S.Box>
    </S.Container>
  );
};

export default PlacementsForm;
